var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from 'mobx';
import { ChoiceOfLanguages, CompanyUserRoles } from '../enums';
import { getCookie } from '../utils/Cookie';
export class UserStore {
    constructor(rootStore) {
        this.user = {
            companyId: -1,
            id: -1,
            email: '',
            firstName: '',
            lastName: '',
            phoneNumber: '',
            roles: [{ role: CompanyUserRoles.CompanyUser, referenceId: null }],
            userRole: CompanyUserRoles.CompanyUser,
            language: ChoiceOfLanguages.Svenska,
        };
        this.updateUser();
    }
    get name() {
        var _a, _b;
        return [(_a = this.user) === null || _a === void 0 ? void 0 : _a.firstName, (_b = this.user) === null || _b === void 0 ? void 0 : _b.lastName].filter(Boolean).join(' ');
    }
    get firstName() {
        var _a;
        return (_a = this.user) === null || _a === void 0 ? void 0 : _a.firstName;
    }
    get userId() {
        var _a;
        return (_a = this.user) === null || _a === void 0 ? void 0 : _a.id;
    }
    updateUser() {
        Object.assign(this.user, getCookie());
    }
}
__decorate([
    observable
], UserStore.prototype, "user", void 0);
__decorate([
    computed
], UserStore.prototype, "name", null);
__decorate([
    computed
], UserStore.prototype, "firstName", null);
__decorate([
    computed
], UserStore.prototype, "userId", null);
__decorate([
    action
], UserStore.prototype, "updateUser", null);
